// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import type {MachineDefinition} from '@core/machine'

/** Only small lamp lenses are opaque on a clear upper deck, never a second full board print. */
export function raisedDeckInserts(definition:MachineDefinition,layerId:string,z:number){
  const positions:number[]=[],normals:number[]=[],uvs:number[]=[],indices:number[]=[]
  const {width,length}=definition.dimensions.playfield
  for(const lamp of definition.lamps??[]){
    if(lamp.kind!=='insert'||lamp.group!==layerId||lamp.position===undefined)continue
    const [x,y]=lamp.position,r=(lamp.radius??.006)+.0015,first=positions.length/3
    const vertex=(px:number,py:number)=>{positions.push(px,py,z+.0001);normals.push(0,0,1);uvs.push(px/width+.5,py/length+.5)}
    vertex(x,y)
    for(let i=0;i<24;i++){const angle=i*Math.PI*2/24;vertex(x+Math.cos(angle)*r,y+Math.sin(angle)*r)}
    for(let i=0;i<24;i++)indices.push(first,first+1+i,first+1+(i+1)%24)
  }
  return {positions,normals,uvs,indices}
}
